<template>
    <div class="lib">

        <div style="display:flex; flex-wrap: wrap;">
            <div class="btns" v-for="i in Items" :key="i.name">
                <button id="bt" v-show="i.name != null" class="border-button" @click="settLock(i); setColor(i.name);">
                    {{ i.name }}
                </button>
            </div>

        </div>


        <div class="item" v-show="nItem > 0">

            <div class="head">
                <div class="audioblock">
                    <h3>{{ Items[nItem].name }}</h3>
                    <audio :src='Items[nItem].audio' controls></audio>
                    <p><i>Рекомендуется уменьшить громкость вашего устройства или проигрывателя, т.к. громкость
                            по-умолчанию - максимальная.</i></p>
                </div>
                <img :src='Items[nItem].img' alt="">
            </div>

            <div class="info">
                <div class="text">
                    <h4>
                        {{ Items[nItem].text }}
                    </h4>

                    <a :href='Items[nItem].wiki' target="_blank">{{ Items[nItem].name }} на Вики</a>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import AudioItem from '@/ui/AudioItem.vue';

export default {
    props: {
        Items: Array,
    },
    components: { AudioItem },
    data() {
        return {

            isClick: false,

            nItem: 0,

            aItem: false,
        }
    },
    methods: {

        settLock(i) {
            this.nItem = this.Items.indexOf(i);
        },

        setColor(i) {
            if (i == Items[nItem].name) {
                document.getElementById('bt').style.backgroundColor = 'red;'
            }
        }
    }
}
</script>

<style scoped>
.lib {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;

    flex-direction: column;
    /*  border: 1px solid yellow; */
}

.btns {
    /* width: 15%;
    height: 80px; */
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1px;
    /*   flex-direction: row;
    flex-wrap: wrap;

    border: 1px solid red; */
}

.btn {
    width: 100%;
    height: 100%;
    /* background-color: blue; */
    margin: 1px;
    border-radius: 50%;

}

.onclick {
    width: 20%;
    height: 60%;
    /* background-color: red; */
}

.head {
    display: flex;
    flex-direction: row;
}

.audioblock {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-left: 3%;
}

img {
    width: 50%;
    height: 50%;
    margin-left: 3%;
}

.item {
    display: flex;
    align-items: center;
    flex-direction: column;
}

p, h4, h3 {
    color: aliceblue;
}

.border-button {
  text-decoration: none;
  display: inline-block;
  padding: 20px 30px;
  margin: 10px 20px;
  position: relative;
  color: white;
  border: 1px solid rgba(255, 255, 255, .4);
  background: none;
  font-weight: 300;
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  letter-spacing: 2px;
  border-radius: 50%;
  width: 100%;
  height: 100%;
}
.border-button:before, .border-button:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  box-sizing: border-box;
  border-radius: 50%;
}
.border-button:before {
  bottom: 0;
  left: 0;
  border-left: 1px solid white;
  border-top: 1px solid white;
/*   transition: 0s ease opacity .8s, .2s ease width .4s, .2s ease height .6s; */
  border-radius: 50%;
}
.border-button:after {
  top: 0;
  right: 0;
  border-right: 1px solid white;
  border-bottom: 1px solid white;
  /* transition: 0s ease opacity .4s, .2s ease width, .2s ease height .2s; */
  border-radius: 50%;
}
.border-button:hover:before, 
.border-button:hover:after {
  height: 100%;
  width: 100%;
  opacity: 1;
}
/* .border-button:hover:before {
  transition: 0s ease opacity 0s, .2s ease height, .2s ease width .2s;
  border-radius: 50%;
}
.border-button:hover:after {
  transition: 0s ease opacity .4s, .2s ease height .4s, .2s ease width .6s;
  border-radius: 50%;
}
.border-button:hover {
  background: rgba(255, 255, 255, .2);
} */
</style>